import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading text-2xl whitespace-nowrap transition-colors duration-200 ${
              scrolled || !isHome ? 'text-primary-500' : 'text-background-50'
            }`}
          >
            狠狠爱
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              首页
            </Link>

            <div className="relative" onMouseEnter={() => setCategoryOpen(true)} onMouseLeave={() => setCategoryOpen(false)}>
              <button
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                分类浏览
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </span>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 bg-background-50 rounded-lg border border-background-200/70 py-2 w-48 z-50">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4 px-4">
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 transition-colors">
                首页
              </Link>
              <div>
                <p className="text-sm font-medium text-foreground-500 py-2">分类浏览</p>
                <div className="flex flex-col gap-1 pl-3">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 py-1.5 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
              <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 transition-colors">
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}